module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/1@2x_58903547b4faa4349a12bd22a297a649.png";